module.exports = __webpack_public_path__ + "static/img/avatar.df7a578.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/avatar.png
// module id = K2Qm
// module chunks = 15